import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    name = '',
    orgType = 0,
    qq = '',
    email = '',
    contactPer = '',
    contactTel = '',
    province = '',
    city = '',
    county = '',
    address = '',
    industryId = '',
    createId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.org.save, {
        id,
        name,
        orgType,
        qq,
        email,
        contactPer,
        contactTel,
        province,
        city,
        county,
        address,
        industryId,
        createId,
    }, options);
    if (error) return { error, status };
    return content || {};
};
